import { createPortal } from 'react-dom';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import './tivigoToast.css';

const TOAST_TYPES = new Set(['success', 'warning', 'error', 'info']);
const TOAST_ICONS = {
  success: CheckCircleRoundedIcon,
  warning: WarningAmberRoundedIcon,
  error: ErrorRoundedIcon,
  info: InfoOutlinedIcon,
};

function TivigoToast({ notice, type, message, text }) {
  const requestedType = notice?.type ?? notice?.tone ?? type;
  const resolvedType = TOAST_TYPES.has(requestedType) ? requestedType : 'info';
  const resolvedText = notice?.text ?? notice?.message ?? message ?? text ?? '';

  if (!resolvedText || typeof document === 'undefined') return null;

  const isError = resolvedType === 'error';
  const toastKey = notice?.id ?? `${resolvedType}-${resolvedText}`;
  const ToastIcon = TOAST_ICONS[resolvedType];

  return createPortal(
    <div
      key={toastKey}
      className={`tvup-theme-toast is-${resolvedType}`}
      role={isError ? 'alert' : 'status'}
      aria-live={isError ? 'assertive' : 'polite'}
    >
      <span className="tvup-theme-toast-icon" aria-hidden="true"><ToastIcon /></span>
      <span className="tvup-theme-toast-copy">{resolvedText}</span>
    </div>,
    document.body,
  );
}

export default TivigoToast;
